/**
 * Parte el texto de una opción de declaración jurada para resaltar SI / NO / SÍ
 * como palabras completas (copys desde backend, sin HTML).
 */
const DECLARACION_OPTION_KEYWORD_SPLIT =
  /(\b(?:NO|SI|SÍ|No|Si|no|si|sí|Sí)\b)/g;

export function declaracionOptionKeywordSegments(text: string): {
  text: string;
  emphasize: boolean;
}[] {
  if (!text) {
    return [];
  }
  const parts = text
    .split(DECLARACION_OPTION_KEYWORD_SPLIT)
    .filter((p) => p.length > 0);
  return parts.map((part) => ({
    text: part,
    emphasize: /^(NO|SI|SÍ|No|Si|no|si|sí|Sí)$/.test(part),
  }));
}
